"use client";

import { Switch } from "@/components/ui/switch";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const data = [
  {
    title: "Newsletter",
    description:
      "Send me email related to updates, special offers, events and new features.",
    checked: false,
  },
  {
    title: "Market Trends",
    description:
      "Send me email related to trends, newly added coins, events and delisted coins from the market.",
    checked: true,
  },
  {
    title: "Rewards",
    description:
      "Send me email related to the newly added coins and tokens on the rewards.",
    checked: true,
  },
];

export function NotificationCard() {
  return (
    <Card className="flex flex-col bg-transparent">
      <CardHeader className="px-5 pt-3.5">
        <CardTitle className="text-lg">Notification Settings</CardTitle>
      </CardHeader>
      <CardContent className="mt-6 space-y-6 px-5 pb-0">
        {data.map(({ title, description, checked }) => (
          <label
            key={title}
            htmlFor={title}
            className="flex cursor-pointer items-center justify-between select-none"
          >
            <div className="space-y-1">
              <p className="font-medium text-white">{title}</p>
              <p className="text-foreground max-w-xs text-xs font-medium">
                {description}
              </p>
            </div>
            <Switch
              id={title}
              defaultChecked={checked}
              aria-label={`${title} switch`}
            />
          </label>
        ))}
      </CardContent>
      <CardFooter className="mt-auto flex justify-end pt-6">
        <Button size="lg" className="px-4">
          Save
        </Button>
      </CardFooter>
    </Card>
  );
}
